import type { SorterResult } from "antd/lib/table/interface";
import { type ExtendedColumnsType, GenericTable, type ResourceTableProps } from "components";
import { type FC, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import {
    displayDateTimeValue,
    displayStatusValue,
} from "../../../../../components/Table/components/PropertyTable/transformations/cellTransformations";
import { ResourceName } from "../../../../../core/router/config/ResourceName";
import { BASE_PATH, FORM_ACTION } from "../../../../../core/router/types/routerTypes";
import type { AlertList } from "../../types/AlertList";

export const AlertsTable: FC<ResourceTableProps<AlertList>> = ({ onStateChanged, onRowSelectionChange, datasource, resource }) => {
    const { t } = useTranslation();
    const getColumnsConfig = useCallback(
        (sortInfo: SorterResult<AlertList>): ExtendedColumnsType<AlertList>[] => {
            return [
                {
                    title: t("list.form.id"),
                    dataIndex: "id",
                    key: "id",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "id" ? sortInfo.order : null,
                },
                {
                    title: t("alertSearchForm.criteriaBadges.pan"),
                    dataIndex: "pan",
                    key: "pan",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "pan" ? sortInfo.order : null,
                },
                {
                    title: t("alertSearchForm.criteriaBadges.status"),
                    dataIndex: "active",
                    key: "active",
                    sorter: () => 0,
                    sortOrder: sortInfo.columnKey === "active" ? sortInfo.order : null,
                    render: (value) => displayStatusValue(value),
                },
                {
                    title: t("genericTable.column.changed"),
                    dataIndex: "changed",
                    key: "changed",
                    render: (value) => displayDateTimeValue(value),
                },
            ];
        },
        [t],
    );

    const navigate = useNavigate();
    const onRowClick = (record: AlertList) => navigate(`${BASE_PATH}/${ResourceName.ALERTS}/${FORM_ACTION.EDIT}/${record.id}`);

    return (
        (datasource && (
            <GenericTable<AlertList>
                getColumnsConfig={getColumnsConfig}
                datasource={datasource}
                name="alerts_table"
                onSelectionCallback={onRowSelectionChange}
                onStateChanged={onStateChanged}
                onRow={(record: AlertList) => {
                    return {
                        onClick: () => onRowClick(record),
                    };
                }}
                resource={resource}
            />
        )) ||
        null
    );
};
